import type { AttachmentKind } from './types.js';
import { getExtension } from './file-kind.js';
import { parseVideoEmbedUrl } from './video-embed.js';

const IMAGE_EXT = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'svg', 'bmp']);
const VIDEO_EXT = new Set(['mp4', 'webm', 'ogg', 'mov', 'm4v']);
const AUDIO_EXT = new Set(['mp3', 'wav', 'ogg', 'm4a', 'aac', 'opus', 'webm']);

const URL_IN_TEXT =
  /https?:\/\/[^\s<>"']+/gi;

export function extractUrlsFromText(text: string): string[] {
  const matches = text.match(URL_IN_TEXT);
  if (!matches) return [];
  return [...new Set(matches.map((u) => u.replace(/[),.]+$/, '')))];
}

export function classifyMediaUrl(url: string): AttachmentKind | 'video_embed' | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  // Prose with dots (e.g. "рп. вап") is not a file URL.
  if (!/^https?:\/\//i.test(trimmed)) {
    return null;
  }

  if (parseVideoEmbedUrl(trimmed)) return 'video_embed';

  const ext = getExtension(trimmed);
  if (IMAGE_EXT.has(ext)) return 'image';
  if (VIDEO_EXT.has(ext)) return 'video';
  if (AUDIO_EXT.has(ext)) return 'audio';
  if (ext) return 'file';

  const lower = trimmed.toLowerCase();
  if (/\.(jpe?g|png|gif|webp)(\?|$)/i.test(lower)) return 'image';
  if (/\.(mp4|webm|mov)(\?|$)/i.test(lower)) return 'video';
  if (/\.(mp3|wav|m4a|ogg)(\?|$)/i.test(lower)) return 'audio';

  return null;
}
